import { DOCUMENTS_LIST_WIDTH_REDESIGN, DOCUMENTS_TREE_HEADER_HEIGHT } from 'constants/documents';
import { mediaQuery } from 'constants/ui';

export const getStyles = ({ palette }, { isView } = {}) => {
  const isDarkTheme = palette.type === 'dark';
  const treeWidth = DOCUMENTS_LIST_WIDTH_REDESIGN;

  return {
    category: {
      backgroundColor: isDarkTheme ? palette.grey['700'] : palette.grey['400'],
      paddingTop: '6px',
      paddingBottom: '6px',
      borderBottom: `1px solid ${palette.grey['200']}`,
      '&:hover': {
        backgroundColor: isDarkTheme ? '#383838' : palette.action.hover,
      },
    },
    name: {
      flex: 1,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      paddingRight: '30px',
    },
    counter: {
      fontSize: '12px',
      borderRadius: '10px',
      backgroundColor: palette.background.paper,
      color: palette.text.primary,
      padding: '0 8px',
    },
    documentTree: {
      backgroundColor: palette.background.paper,
      overflow: 'hidden',
      display: isView ? 'flex' : 'none',
      flexDirection: 'column',
      height: '100%',
      maxHeight: '100vh',
      width: `${treeWidth}px`,
      minWidth: `${treeWidth}px`,
      color: palette.common.white,
      borderRight: `1px solid ${palette.divider}`,

      // On mobile the tree+preview stack vertically, so the tree spans the full
      // width and divides with a bottom border instead of a fixed-width right rail.
      [mediaQuery.mobile]: {
        width: '100%',
        minWidth: '100%',
        maxHeight: 'none',
        borderRight: 'none',
        borderBottom: `1px solid ${palette.divider}`,
      },
    },
    documentsListWrapper: {
      height: `calc(100% - ${DOCUMENTS_TREE_HEADER_HEIGHT}px) !important`,
    },
  };
};
